import ConstantsModule from "./constants.module";

// taken from https://support.microsoft.com/en-us/help/208427/maximum-url-length-is-2-083-characters-in-internet-explorer
//
ConstantsModule.constant("MAX_URL_LENGTH_INTERNET_EXPLORER", 2083);

export default name;
